<template>
    <div>
        <b-form @submit.prevent="onSubmit">
            <b-row class="mt-3">
                <b-col cols="12" class="d-flex justify-content-end">
                    <b-button variant="primary" @click="showContratadaFinder">
                        +
                    </b-button>
                    <LgFinderPageContratada :prefix="prefix" ref="contratadaFinder" :multiple="false"
                        @onSelect="addContratada" style="display: none;" />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-table small :items="contratoForm.contratadas" :fields="contratadasFields" responsive>
                        <template #cell(actions)="data">
                            <b-button size="sm" variant="danger" @click="removeContratada(data.item)">
                                <b-icon icon="trash"></b-icon>

                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
import LgFinderPageContratada from "@/components/Finders/LgFinderPageContratada.vue";

export default {
    name: "ContratoForm",
    components: {
        LgFinderPageContratada,
    },
    props: {
        id: {
            type: String,
            default: ''
        },

        prefix: {
            type: String,
            default: ""
        },
        contratoFormParam: {
            type: Object,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            contratoForm: this.contratoFormParam,
            contratadasFields: [
                { key: 'razaoSocial', label: 'Razão Social' },
                { key: 'registro', label: 'Registro' },
                { key: 'actions', label: 'Ações' },
            ],
        };
    },
    methods: {

        onSubmit() {
            this.contratoForm.contratadasIds = this.contratoForm.contratadas
                ? this.contratoForm.contratadas.map(c => c.id)
                : [];
            this.$emit("contratoFormSubmit", this.contratoForm);
        },
        showContratadaFinder() {
            this.$refs.contratadaFinder.show();
        },
        addContratada(item) {
            const contratada = {
                id: item.id,
                razaoSocial: item.razaoSocial,
                registro: item.registroFmt,
            };

            if (!this.contratoForm.contratadas.some(c => c.id === contratada.id)) {
                this.contratoForm.contratadas.push(contratada);
            } else {
                this.$bvToast.toast('Contratada já adicionada', {
                    title: 'Atenção',
                    variant: 'warning',
                    solid: true,
                });
            }
        },
        removeContratada(item) {
            this.contratoForm.contratadas = this.contratoForm.contratadas.filter(c => c.id !== item.id);
        },
    },
};
</script>

<style scoped></style>
